import { GatsbyImage } from 'gatsby-plugin-image';

function AvenueGatsbyImage(props) {
    const { title, localFile, className } = props;

    const isSvg = (val) => {
        return val?.extension === 'svg';
    };

    if (isSvg(localFile)) {
        return <img src={localFile.publicURL} alt={title} aria-label={title} className={className} />;
    }

    return (
        <GatsbyImage
            image={localFile?.childImageSharp?.gatsbyImageData}
            alt={title}
            aria-label={title}
            className={className}
        />
    );
}

export default AvenueGatsbyImage;
